import React from "react";
import "./App.css";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { ToastContainer } from "react-toastify";
import { AppRouter } from "./routes";
import "react-toastify/dist/ReactToastify.css";
function App() {
  return (
    <div>
      <GoogleOAuthProvider clientId="548547931906-ack7gllr0qgg25f935cpmsp3empubv7t.apps.googleusercontent.com">
        <ToastContainer />
        <AppRouter />
      </GoogleOAuthProvider>
    </div>
  );
}

export default App;
//Test // 505377239968-gh5garq6jif3laf04kvijk972h8vu1e8.apps.googleusercontent.com
//Live // 548547931906-ack7gllr0qgg25f935cpmsp3empubv7t.apps.googleusercontent.com
